module.exports = __webpack_public_path__ + "img/pagsmile.74a21e9.png";